import { StaticPageContent } from "@components/Shared/model/StaticPageContent";
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { MetaContent } from "@components/Shared/model/MetaHelmet";

export const MetaObject: LanguageContent<MetaContent> = {
	en: {
		title: "Ryerson Commitment - Ryerson",
		description:
			"From our people to our products and processes, Ryerson’s commitment to quality runs deep.",
		url: `/why-ryerson/ryerson-commitment`,
		company: true,
	},
	fr: {
		title: "Ryerson Commitment - Ryerson",
		description:
			"From our people to our products and processes, Ryerson’s commitment to quality runs deep.",
		url: `/why-ryerson/ryerson-commitment`,
		company: true,
	},
	es: {
		title: "Ryerson Commitment - Ryerson",
		description:
			"From our people to our products and processes, Ryerson’s commitment to quality runs deep.",
		url: `/why-ryerson/ryerson-commitment`,
		company: true,
	},
};

export const PageContent: StaticPageContent = {
	meta: MetaObject,
	content: [],
};
